<template>
  <b-card>
    <!-- Card body -->
    <b-card-title title-tag="h3" class="mb-3">
      Uptime
      <span style="color: #4fd69c;">{{ website.totalAvgUptime || 100 }}%</span>
      <!--
      <span style="float:right">
        <a class="btn btn-sm btn-neutral">
          30 days
        </a>
        <a class="btn btn-sm btn-neutral">
          60 days
        </a>
        <a class="btn btn-sm btn-neutral">
          90 days
        </a>
      </span>
      -->
    </b-card-title>
    <b-card-text>
      <svg height="34" style="width: 100%;">
        <rect
          v-for="(value, index) in uptimeData"
          v-bind:key="value.id"
          height="34"
          :width="rectWidth || '10'"
          :x="'3.33' * index + '%'"
          y="0"
          :fill="value.incidents.length > 0 ? '#fb6340' : '#4fd69c'"
          class="uptime-day component-8l4ygp009s5s day-43"
          data-html="true"
          :id="'uptime-' + index"
        >
          <b-popover
            :target="'uptime-' + index"
            triggers="hover"
            placement="top"
          >
            <template v-slot:title>{{ value.date }}</template>

            <div v-if="value.incidents.length > 0">
              <div
                v-for="(incident, innerIndex) of value.incidents"
                v-bind:key="innerIndex"
                style="border-bottom: 1px #f2f2f2;"
              >
                <div style="border-bottom: 1px #f2f2f2; padding-bottom: 5px;">
                  <h4>{{ incident.component.name }}</h4>
                  <a :href="incident.shortlink">{{ incident.description }}</a>
                </div>
                <hr
                  style="padding-top: 5px; padding-bottom: 5px; margin: 0px;"
                />
              </div>
            </div>
            <div v-else>
              No issues detected.
            </div>
          </b-popover>
        </rect>
      </svg>
      <span class="uptime-subheader">
        30 days ago
      </span>
      <span class="uptime-subheader" style="float: right;">
        Today
      </span>
    </b-card-text>
    <template v-slot:footer>
      <p class="text-muted mb-0">
        Last 30 days
      </p>
    </template>
  </b-card>
</template>
<script>
import moment from "moment";

export default {
  name: "uptime-chart",
  props: {
    uptimeObj: {
      type: Array,
      default: () => {},
      description: "Uptime object (including incidents)"
    },
    website: {
      type: Object,
      default: () => {},
      description: "Website"
    },
    columns: {
      type: Array,
      default: () => [],
      description: "Table columns"
    },
    data: {
      type: Array,
      default: () => [],
      description: "Table data"
    },
    type: {
      type: String, // striped | hover
      default: "",
      description: "Whether table is striped or hover type"
    },
    theadClasses: {
      type: String,
      default: "",
      description: "<thead> css classes"
    },
    tbodyClasses: {
      type: String,
      default: "",
      description: "<tbody> css classes"
    }
  },
  data() {
    return {
      uptimeData: [],
      rectWidth: 7
    };
  },
  computed: {
    tableClass() {
      return this.type && `table-${this.type}`;
    }
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  },
  computed: {},
  mounted() {
    if (window.innerWidth <= 576) {
      this.rectWidth = 5;
    } else if (window.innerWidth >= 1080) {
      this.rectWidth = 10;
    }

    for (let i = 30; i > 0; i--) {
      this.uptimeData.push({
        id: i,
        incidents: [],
        date: moment().subtract(i, "days").format("MMM D, YYYY")
      });
    }
  },
  watch: {
    uptimeObj: function (uptimeObj) {
      for (const obj of uptimeObj) {
        const { incident, component } = obj;
        //const minorFillColor = "#fb6340";

        /*

        let latestUpdate = 'Degraded Performance'
        switch(incident.impact) {
          case 'maintenance':
            latestUpdate = "Undergoing Maintenance"
          case 'latency':
            latestUpdate = "Latency Issues"
          case 'minor':
            latestUpdate = "Degraded Performance"
          case 'critical':
            latestUpdate = "Major Incident Declared"
        }
         */

        const incidentData = {
          id: incident.id,
          description: incident.name,
          impact: incident.impact,
          shortlink: incident.shortlink,
          date: moment(incident.createdAt).format("MMM D, YYYY"),
          component: component
        };

        /*
        if (["maintenance", "minor"].includes(incident.impact)) {
          incidentData.fillColor = minorFillColor;
        }
         */

        // If this is major, make it major!

        /*
      if (incident.impact === "maintenance" || incident.impact === "minor" || incident.impact === 'none') {
      }
         */

        const incidentDate = moment().diff(incident.createdAt, "days");
        const incidentDateIndex = this.uptimeData.length - incidentDate - 1;
        const incidentArray = this.uptimeData[incidentDateIndex];

        incidentArray.incidents.push(incidentData);

        this.$set(this.uptimeData, incidentDateIndex, incidentArray);
      }
    }
  }
};
</script>
<style>
.uptime-subheader {
  color: #9facbb !important;
  font-size: 14px;
}

.popover-body div:last-child hr {
  display: none;
}
</style>
